export enum WidgetStorageId {
  HostId = 'DESTI1_PHOENIX:HOSTID',
  WidgetLanguage = 'DESTI1_PHOENIX:WIDGETLANGUAGE',
  WidgetCurrency = 'DESTI1_PHOENIX:WIDGETCURRENCY',
  WidgetPreferredCurrency = 'DESTI1_PHOENIX:WIDGETPREFERREDCURRENCY'
}
